export default import.meta.ROLLUP_FILE_URL_RCaHVq_jCUoWDQWiWLxE3w;